import React from 'react';
import {SvgIcon} from '@material-ui/core';
import PropTypes from 'prop-types';

export default function CloseIcon(props) {
    return (
        <SvgIcon width="34" height="34" viewBox="0 0 34 34" {...props}>
            <g fill="none" fillRule="evenodd">
                <circle cx="17" cy="17" r="17" fill="#E8EDF1" fillOpacity=".6" />
                <path fill="#677282" d="M13.258 11.387L17 15.13l3.742-3.743c.517-.516 1.354-.516 1.87 0 .517.517.517 1.354 0 1.87L18.87 17l3.743 3.742c.516.517.516 1.354 0 1.87-.517.517-1.354.517-1.87 0L17 18.87l-3.742 3.743c-.517.516-1.354.516-1.87 0-.517-.517-.517-1.354 0-1.87L15.13 17l-3.743-3.742c-.516-.517-.516-1.354 0-1.87.517-.517 1.354-.517 1.87 0z" />
            </g>
        </SvgIcon>

    );
}

CloseIcon.propTypes = {
    className: PropTypes.string,
};

CloseIcon.defaultProps = {
    className: null,
};



// WEBPACK FOOTER //
// ./src/components/controls/icons/CloseIcon.jsx